import styles from './style.module.scss';

const SalesforceIdInfoLabel = ({ translateText }) => (
  <label className={styles.salesforceLabel}>
    {translateText('corporateAccounts.corporateClient.salesforceId.infoMessage')}
  </label>
);

export default SalesforceIdInfoLabel;
